import { FontWeights, makeStyles } from '@fluentui/react';

export const useStyles = makeStyles((theme) => ({
  iconsRow: {
    marginTop: -5,
    width: 50,
  },
  labelStyle: {
    width: '100%',
    marginLeft: 30,
  },
  labelSubStyle: {
    flexGrow: 1,
    gap: 6,
    width: 220,
    overflow: 'hidden',
  },
}));
